import React, {Component} from 'react';

import {setUser, getUser} from '../../utils/TokenManager';
import {
    ADMIN_DASHBOARD_ALLOWED_ROLLS, ROLL_AGENCY_MONITOR, 
    IW_ALLOWED_ROLLS, STAFF_DASHBOARD_ROLLS
} from "./Constants";
import Dashboard from '../../components/dashboard/Dashboard';
import StaffDashboard from '../../components/staffDashboard/MainDashboard';
import ShowMessages from "./ShowMessages";
import ChangePassword from "./ChangePassword";
import InstallationWizard from '../installationWizard/InstallationWizard';
import AgencyMonitorDashboard from '../../containers/AgencyMonitor/AgencyMoniorDashboard';
import * as AuthAction from './../../actions/AuthAction';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

class CommonDashboard extends Component {
    state = {
        hasUnreadMessage: false,
        isFirstTimeLogin: false,
        isInstallationCompleted: false,
        userDetails: {}
    }

    componentDidMount = () => {
        this.getInitialState();
    };

    getInitialState = () => {
        let userDetails = getUser();
        let newUserDetails = {...userDetails};
        let hasUnreadMessage = false, isFirstTimeLogin = false, isInstallationCompleted = false;
        if (newUserDetails.first_time_login) {
            isFirstTimeLogin = true;
        }
        if (newUserDetails.no_of_unread_messages > 0) {
            hasUnreadMessage = true;
        }
        if (newUserDetails.is_installation_completed) {
            isInstallationCompleted = true
        }
        this.setState({
            userDetails: newUserDetails, 
            isFirstTimeLogin, hasUnreadMessage, 
            isInstallationCompleted
        });
        // await this.getPermissions(userDetails.id);
    };

    closeMessage = async () => {
        let newUserDetails = {...this.state.userDetails};
        newUserDetails['no_of_unread_messages'] = 0;
        this.setState({userDetails: newUserDetails, hasUnreadMessage: false});
        setUser(newUserDetails);
    };

    closePasswordSetting = async () => {
        let newUserDetails = {...this.state.userDetails};
        newUserDetails['first_time_login'] = false;
        this.setState({userDetails: newUserDetails, isFirstTimeLogin: false});
        setUser(newUserDetails);
    };

    logout = () => {
        const {userDetails} = this.state;
    
        if (userDetails.id > 0) {
            this.props.authAction.logOut();
        }
    };

    getPermissions = async (userId) => {
        try {
            await this.props.authAction.getPermissions(userId);
        } catch (error) {
            console.log(error);
        }
    }

    render() {
        const {
            isFirstTimeLogin, hasUnreadMessage, userDetails, isInstallationCompleted
        } = this.state;

        if (isFirstTimeLogin) {
            return (<ChangePassword closePasswordSetting={this.closePasswordSetting} />);
        } else if (userDetails.role && userDetails.role.access_level_value === ROLL_AGENCY_MONITOR) {
            return (<AgencyMonitorDashboard />);
        } else if (hasUnreadMessage) {
            return (<ShowMessages closeMessage={this.closeMessage} />);
        } else if (userDetails.role && (
            IW_ALLOWED_ROLLS.includes(userDetails.role.access_level_value)
        ) && !isInstallationCompleted) {
            return (<InstallationWizard />);        
        } else if (userDetails.role && (
            ADMIN_DASHBOARD_ALLOWED_ROLLS.includes(userDetails.role.access_level_value))
        ) {
            return (<Dashboard />);
        } else if (userDetails.role && 
            STAFF_DASHBOARD_ROLLS.includes(userDetails.role.access_level_value)
        ) {
            return (<StaffDashboard />);
        } else {
            return (
                <div className="container text-center h-100">
                    <h1 className="mt-5">Page not working</h1>
                    {/* temporary call automatic logout, 
                    remove after some time after going to production */}
                    <a href="#" onClick={this.logout()}>
                        Please click here to Logout
                    </a>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        agencyLocation: state.AgencyLocationReducer,
        auth: state.AuthReducer
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        authAction: bindActionCreators(AuthAction, dispatch)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommonDashboard);


// WEBPACK FOOTER //
// ./src/components/common/CommonDashboard.js